import { render, staticRenderFns } from "./sdproduct15.vue?vue&type=template&id=e7f9fe8e&scoped=true"
import script from "./sdproduct15.vue?vue&type=script&lang=js"
export * from "./sdproduct15.vue?vue&type=script&lang=js"
import style0 from "./sdproduct15.vue?vue&type=style&index=0&id=e7f9fe8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f9fe8e",
  null
  
)

export default component.exports